/**
 * 創建所有階段的選單群組（A-3：分層架構）
 * 在每個頁面都顯示全部階段的入口按鈕，非當前階段的縮起來
 */
import {
  Home as PrepHomeIcon,
  Book as BookIcon,
  School as ClassIcon,
  Send as SendIcon,
  Person as PersonIcon
} from '@mui/icons-material';
import {
  Home as ImplHomeIcon,
  Dashboard as DashboardIcon,
  Assignment as AssignmentIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Lightbulb as LightbulbIcon,
  Groups as GroupsIcon
} from '@mui/icons-material';
import {
  Assessment as DiagnosisIcon,
  CompareArrows as CompareArrowsIcon
} from '@mui/icons-material';

/**
 * 創建所有階段的選單群組
 * @param {string} currentPhase - 當前階段：'preparation' | 'implementation' | 'diagnosis'
 * @param {string} activeItem - 當前活動項目（用於標記 active）
 * @param {function} navigate - 導航函數
 * @param {number|null} courseId - 課程ID（課中實施階段需要，可選）
 * @returns {object} 包含三個階段選單群組的對象
 */
export const createAllPhaseMenuGroups = (currentPhase, activeItem, navigate, courseId = null) => {
  // 課前準備階段選單
  const preparationMenu = {
    title: '課前準備',
    items: [
      {
        icon: PrepHomeIcon,
        text: '快速入口',
        active: currentPhase === 'preparation' && activeItem === 'home',
        onClick: () => navigate('/teacher/preparation')
      },
      {
        icon: BookIcon,
        text: '備課包管理',
        active: currentPhase === 'preparation' && activeItem === 'lesson-packages',
        onClick: () => navigate('/teacher/preparation/lesson-packages')
      },
      {
        icon: ClassIcon,
        text: '社群管理',
        active: currentPhase === 'preparation' && activeItem === 'communities',
        onClick: () => navigate('/teacher/preparation/communities')
      },
      {
        icon: SendIcon,
        text: '課程派發',
        active: currentPhase === 'preparation' && activeItem === 'course-dispatch',
        onClick: () => navigate('/teacher/preparation/course-dispatch')
      },
      {
        icon: PersonIcon,
        text: '學生管理',
        active: currentPhase === 'preparation' && activeItem === 'students',
        onClick: () => navigate('/teacher/preparation/students')
      }
    ]
  };

  // 課中實施階段選單
  const implementationMenu = {
    title: '課中實施',
    items: [
      {
        icon: ImplHomeIcon,
        text: '快速入口',
        active: currentPhase === 'implementation' && activeItem === 'home',
        onClick: () => navigate('/teacher/implementation'),
        disabled: false
      },
      {
        icon: AssignmentIcon,
        text: '任務管理',
        active: currentPhase === 'implementation' && activeItem === 'task-dispatch',
        onClick: courseId 
          ? () => navigate(`/teacher/implementation/community-applications/${courseId}/task-dispatch`)
          : () => navigate('/teacher/implementation'),
        disabled: !courseId
      },
      {
        icon: LightbulbIcon,
        text: '想法牆管理',
        active: currentPhase === 'implementation' && activeItem === 'idea-wall',
        onClick: courseId 
          ? () => navigate(`/teacher/implementation/community-applications/${courseId}/idea-wall`)
          : () => navigate('/teacher/implementation'),
        disabled: !courseId
      },
      {
        icon: QuestionAnswerIcon,
        text: '問題牆管理',
        active: currentPhase === 'implementation' && activeItem === 'question-wall',
        onClick: courseId 
          ? () => navigate(`/teacher/implementation/community-applications/${courseId}/question-wall`)
          : () => navigate('/teacher/implementation'),
        disabled: !courseId
      },
      {
        icon: GroupsIcon,
        text: '跨組討論',
        active: currentPhase === 'implementation' && activeItem === 'cross-group',
        onClick: courseId 
          ? () => navigate(`/teacher/implementation/community-applications/${courseId}/cross-group-discussion`)
          : () => navigate('/teacher/implementation'),
        disabled: !courseId
      },
      {
        icon: DashboardIcon,
        text: '學習儀表板',
        active: currentPhase === 'implementation' && activeItem === 'dashboard',
        onClick: courseId 
          ? () => navigate(`/teacher/implementation/community-applications/${courseId}/analytics`)
          : () => navigate('/teacher/implementation'),
        disabled: !courseId
      }
    ]
  };

  // 課後分析階段選單
  const diagnosisMenu = {
    title: '課後診斷',
    items: [
      {
        icon: DiagnosisIcon,
        text: '課後診斷',
        active: currentPhase === 'diagnosis' && activeItem === 'diagnosis',
        onClick: () => navigate('/teacher/diagnosis')
      },
     
    ]
  };

  return {
    preparation: [preparationMenu],
    implementation: [implementationMenu],
    diagnosis: [diagnosisMenu]
  };
};

